<template>
    <div>

        <body>
            <!-- preloader end -->

            <!-- ======== header start ======== -->
            <header class="header">
                <div class="navbar-area">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-lg-12">
                                <nav class="navbar navbar-expand-lg">
                                    <router-link class="navbar-brand" :to="{ name: 'homepage' }">
                                        <BrandSignature
                                            :src="require('@/homepage-assets/images/logo/logo.svg')"
                                            logo-width="180px"
                                            size="small"
                                            theme="light"
                                        />
                                    </router-link>
                                    <button class="navbar-toggler" type="button" data-toggle="collapse"
                                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                        aria-expanded="false" aria-label="Toggle navigation">
                                        <span class="toggler-icon"></span>
                                        <span class="toggler-icon"></span>
                                        <span class="toggler-icon"></span>
                                    </button>

                                    <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                                        <ul id="nav" class="navbar-nav">
                                            <!--ms-auto-->
                                            <li class="nav-item">
                                                <router-link class="nav-link" :to="{ name: 'homepage' }">{{
                                                    $t('messages.login') }}</router-link>
                                            </li>
                                            <li class="nav-item">
                                                <router-link class="nav-link" :to="{ name: 'homepage' }">{{
                                                    $t('homepage.whats') }}?</router-link>
                                            </li>
                                            <li class="nav-item">
                                                <router-link class="nav-link" :to="{ name: 'homepage' }">{{
                                                    $t('homepage.What_Can_I_Do') }}?</router-link>
                                            </li>
                                            <li class="nav-item">
                                                <router-link class="nav-link" :to="{ name: 'homepage' }">{{
                                                    $t('homepage.features') }}</router-link>
                                            </li>
                                            <li class="nav-item">
                                                <router-link class="nav-link" :to="{ name: 'homepage' }">{{
                                                    $t('homepage.contact') }}</router-link>
                                            </li>

                                        </ul>
                                    </div>
                                    <!-- navbar collapse -->

                                    <!-- <a href="#" class="main-btn border-btn btn-hover d-none d-sm-block"><i class="lni lni-calendar"></i> Bir Demo Planlayın</a> -->
                                    <!-- <a style="border:2px solid #fff !important; font-weight:600;" href="/#/login" class="main-btn border-btn btn-hover d-none d-sm-block"><i class="lni lni-arrow-right-circle"></i> Giriş Yap</a> -->
                                    <a :uk-tooltip="`title: ${$t('home.languages')} ; pos: bottom ;offset:0`
                                        " class="header-widget-icon" href="javascript:void(0)">
                                        <img class="h-23px w-23px rounded-sm" :src="languageFlag || getLanguageFlag"
                                            alt="" />

                                    </a>
                                    <!-- Language dropdown -->
                                    <div ref="languageRefs" class="dropdown-notifications dropdown-languages"
                                        uk-dropdown=" pos: top-right;mode:click">
                                        <!-- notification contents -->
                                        <div class="dropdown-notifications-content" data-simplebar>
                                            <!-- notiviation list -->
                                            <ul style="background-color: white;">
                                                <template v-for="(item, i) in languages">
                                                    <li v-if="item.lang !== activeLanguage" class="navi-item" :class="{
                                                        'navi-item-active': isActiveLanguage(item.lang),
                                                    }" :key="i">
                                                        <a href="#" class="navi-link" v-bind:data-lang="item.lang"
                                                            v-on:click="selectedLanguage">
                                                            <span class="symbol symbol-20 mr-3">
                                                                <img :src="item.flag" alt=""
                                                                    class="h-23px w-23px rounded-sm" />
                                                            </span>
                                                            <span class="navi-text">{{ item.name }}</span>
                                                        </a>
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                                <!-- navbar -->
                            </div>
                        </div>
                        <!-- row -->
                    </div>
                    <!-- container -->
                </div>
                <!-- navbar area -->
            </header>
            <!-- ======== header end ======== -->



            <!-- ======== hero-section start ======== -->
            <section class="hero-section v2">
                <div class="container">
                    <div class="row align-items-center position-relative">
                        <div class="col-lg-6 offset-lg-3">
                            <div class="hero-content">
                                <br>
                                <br>
                                <br>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <!-- ======== hero-section end ======== -->


            <!-- ======== properties-section start ======== -->
            <section id="properties" class="properties-section">
                <div class="properties-wrapper container">
                    <div class="row">
                        <div class="col-md-6 offset-md-3 text-center pb-50">
                            <div class="d-flex align-items-center justify-content-centerf flex-column">
                                <BrandSignature
                                    :src="require('@/homepage-assets/images/logo/logo-2.svg')"
                                    class="policies-brand-signature"
                                    logo-width="300px"
                                    size="large"
                                />
                                <div class="section-title">
                                    <h2 class="color-primary">Sözleşme ve Politikalar</h2>
                                </div>
                            </div>
                        </div>

                        <div class="nav-pills-wrapper">
                            <div class="nav flex-column nav-pills me-3 col-md-3 wow fadeInRight" data-wow-delay=".5s"
                                id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                <!--<button class="nav-link active" id="v-pills-kullanici-sozlesmesi-tab" data-bs-toggle="pill" data-bs-target="#v-pills-kullanici-sozlesmesi" type="button" role="tab" aria-controls="v-pills-kullanici-sozlesmesi" aria-selected="true"><i class="lni lni-empty-file"></i> Kullanıcı Sözleşmesi</button>-->
                                <button class="nav-link active" id="v-pills-gizlilik-tab" data-toggle="pill"
                                    data-target="#v-pills-gizlilik" type="button" role="tab"
                                    aria-controls="v-pills-gizlilik" aria-selected="true"><i class="lni lni-empty-file"></i>
                                    Gizlilik Politikası</button>
                                <!--<button class="nav-link" id="v-pills-bilgi-guvenligi-tab" data-bs-toggle="pill" data-bs-target="#v-pills-bilgi-guvenligi" type="button" role="tab" aria-controls="v-pills-bilgi-guvenligi" aria-selected="false"><i class="lni lni-empty-file"></i> Bilgi Güvenliği Politikası</button>-->
                                <!--<button class="nav-link" id="v-pills-kvkk-tab" data-bs-toggle="pill" data-bs-target="#v-pills-kvkk" type="button" role="tab" aria-controls="v-pills-kvkk" aria-selected="false"><i class="lni lni-empty-file"></i> KVKK Aydınlatma Metni</button>-->
                                <!--<button class="nav-link" id="v-pills-cerez-tab" data-bs-toggle="pill" data-bs-target="#v-pills-cerez" type="button" role="tab" aria-controls="v-pills-cerez" aria-selected="false"><i class="lni lni-empty-file"></i> Çerez Politikası</button>-->
                            </div>
                            <div class="tab-content col-md-9 v2 wow fadeInLeft " data-wow-delay=".5s"
                                id="v-pills-tabContent" style="height:auto;">
                                <div class="tab-pane fade show active" id="v-pills-gizlilik" role="tabpanel"
                                    aria-labelledby="v-pills-gizlilik-tab">
                                    <p>Bu gizlilik politikası ile Softinya LMS internet sitesi <span>softinya.com</span>
                                        (Gizlilik politikasında “<span>softinya.com</span>” olarak anılacaktır) üzerinden
                                        kullanıcıların <span>softinya.com</span>’de bulunan kişisel bilgilerinin kullanımı
                                        ve korunması düzenlenmektedir.</p>
                                    <p>Kullanıcıların kişisel bilgileri, adı – soyadı, doğum tarihi, telefon numarası,
                                        e-posta adresi, T.C kimlik numarası gibi kullanıcıyı doğrudan ya da dolaylı olarak
                                        tanımlamaya yönelik her türlü kişisel bilgi olup, bu gizlilik politikasında “kişisel
                                        bilgiler” olarak anılacaktır.</p>
                                    <p><span>softinya.com</span> kullanıcılarının kişisel bilgileri, bu gizlilik politikası
                                        ile belirlenen esas ve kapsam haricinde hiçbir şekilde kullanılmayacak ve ancak
                                        kullanıcının açık rızası ile üçüncü kişilerle paylaşılacaktır.</p>
                                    <p><span>softinya.com</span>, kişisel bilgilerin ve <span>softinya.com</span>
                                        kullanıcılarının gerçekleştirmiş olduğu işlem bilgilerinin güvenliğini ve
                                        gizliliğini sağlamak için gerekli önlemleri almaktadır. <span>softinya.com</span> bu
                                        amaçla, başka programlar kullanabilir. Ancak, <span>softinya.com</span> tarafından
                                        gerekli bilgi güvenliği önlemlerinin almasına karşın internet sitesine ve/veya
                                        sisteme yapılan saldırılar sonucunda kişisel bilgilerin zarar görmesi veya üçüncü
                                        kişilerin eline geçmesi durumunda, <span>softinya.com</span>’un bu nedenle herhangi
                                        bir sorumluluğu olmayacaktır.</p>
                                    <p>Bir kullanıcının, bir başka kullanıcının bilgilerine ulaşması ve bu bilgileri
                                        değiştirmesi mümkün değildir. Kullanıcının kişisel bilgileri,
                                        <span>softinya.com</span> haricinde yalnızca kullanıcı tarafından ulaşılabilir ve bu
                                        bilgiler ancak kullanıcı tarafından güncellenebilir. Kullanıcının talebi ile kişisel
                                        bilgiler <span>softinya.com</span> tarafından da güncellenebilecektir.
                                    </p>
                                    <p><span>softinya.com</span>, kişisel bilgileri ölçümleme çalışmaları, reklam, tanıtım,
                                        pazarlama ile sair iletişim faaliyetleri amacıyla kullanabileceği ve Grup Şirketleri
                                        ile iş ortaklarıyla paylaşabileceği gibi <span>softinya.com</span> tarafından
                                        sunulan hizmet kalitesinin arttırılması ve site faaliyetlerinin daha iyi şekilde
                                        yürütülmesi amacıyla da kayıt altına alınabilir ve kullanabilir.</p>
                                    <p>İdari kurumlar ve adli kurumlar tarafından gelen talepler ve bildirimler
                                        doğrultusunda kişisel bilgiler, Gizlilik Politikasına uygun olarak adli ve idari
                                        kurumlar ile paylaşılabilir.</p>
                                    <p>Kullanıcının kişisel bilgileri; gerçekleştirilen işlemlerde gerekli görülmesi
                                        halinde, sürecin hızlandırılması ve kullanıcılar arasındaki iletişimi sağlamak
                                        amacıyla işleme dahil olan diğer kullanıcı ile paylaşılabilir.</p>
                                    <p><span>softinya.com</span>, internet sayfasını kullanan kullanıcıların istatistiksel
                                        bilgilerini, teknik bir iletişim dosyasını kullanarak elde edebilir. Kullanıcılar
                                        isterse, bu dosyayı engellemeye yönelik tarayıcı ayarlarını değiştirebilirler.</p>
                                    <p><span>softinya.com</span> internet sitesini ziyaret eden her kullanıcı,
                                        <span>softinya.com</span> gizlilik politikası hükümlerini kabul etmiş sayılacaktır.
                                    </p>
                                </div>
                                <!--<div class="tab-pane fade" id="v-pills-bilgi-guvenligi" role="tabpanel" aria-labelledby="v-pills-bilgi-guvenligi-tab">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                        </div>
                        <div class="tab-pane fade" id="v-pills-kvkk" role="tabpanel" aria-labelledby="v-pills-kvkk-tab">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                        </div>
                        <div class="tab-pane fade" id="v-pills-cerez" role="tabpanel" aria-labelledby="v-pills-cerez-tab">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloremque, suscipit ipsum ad libero, illum, aliquam facilis rem nulla dolorum provident ab odit? Omnis saepe fuga natus error ea molestiae perspiciatis?</p>
                        </div>-->


                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- ======== properties-section end ======== -->

            <!-- ======== footer start ======== -->
            <footer class="footer ">
                <div class="container ">
                    <div class="widget-wrapper ">
                        <div class="row ">
                            <div class="col-xl-4 col-lg-4 col-md-6 ">
                                <div class="footer-widget ">
                                    <div class="logo mb-30 ">
                                        <router-link class="navbar-brand" :to="{ name: 'homepage' }">
                                            <BrandSignature
                                                :src="require('@/homepage-assets/images/logo/logo.svg')"
                                                logo-width="180px"
                                                theme="light"
                                            />
                                        </router-link>
                                    </div>
                                    <p class="desc mb-30 text-white ">
                                        <a href="mailto:info@softinya.com"><i class="lni lni-envelope"></i>
                                            info@softinya.com</a>
                                        <a href="tel:0(212)-267-53-73" v-if="activeLanguage === 'tr'"><i
                                                class="lni lni-phone"></i> (0212) 267 53 73</a>
                                        <a href="tel:0(534)-522-08-59" v-if="activeLanguage === 'tr'"><i
                                                class="lni lni-whatsapp"></i> (0534) 522 08 71</a>
                                    </p>
                                </div>
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-6 ">
                                <div class="footer-widget mt-25">
                                    <ul class="links ">
                                        <li> <router-link :to="{ name: 'homepage', hash: '#home' }">{{
                                            this.$t('messages.login')
                                        }}</router-link></li>
                                        <li> <router-link :to="{ name: 'homepage', hash: '#feature' }">{{
                                            $t('homepage.whats') }}?</router-link>
                                        </li>
                                        <li> <router-link :to="{ name: 'homepage', hash: '#about' }">{{
                                            $t('homepage.What_Can_I_Do') }}</router-link>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-6 ">
                                <div class="footer-widget mt-25">
                                    <ul class="links">
                                        <li>
                                            <router-link :to="{ name: 'homepage', hash: '#properties' }">{{
                                                $t('homepage.features') }}</router-link>
                                        </li>
                                        <li>
                                            <router-link :to="{ name: 'homepage', hash: '#contact' }">{{
                                                $t('homepage.contact') }}</router-link>
                                        </li>

                                        <!-- Ayrı sayfa: Policies -->
                                        <li>
                                            <router-link :to="{ name: 'policies' }">{{ $t('homepage.agreements')
                                            }}</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-xl-3 col-lg-3 col-md-6 ">
                                <div class="footer-widget ">
                                    <ul class="socials">
                                        <li>
                                            <a target="_blank" href="https://www.instagram.com/anzeraofficial">
                                                <i class="uil uil-instagram"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank"
                                                href="https://www.linkedin.com/company/anzeraogrenmeteknolojileri">
                                                <i class="uil uil-linkedin"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://wa.me/905495783709?text=Hi">
                                                <i class="uil uil-whatsapp"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </footer>
            <!-- ======== footer end ======== -->

            <!-- ======== scroll-top ======== -->
            <a href="# " class="scroll-top btn-hover ">
                <i class="lni lni-chevron-up "></i>
            </a>

        </body>


    </div>
</template>
<script>
import i18nService from "@/core/services/i18n.service.js";
import BrandSignature from "@/view/layouts/shared/components/BrandSignature.vue";
export default {
    name: "policies",
    components: { BrandSignature },
    data() {
        return {
            languages: i18nService.languages,
            languageFlag: "",
        }
    },
    computed: {

        currentFlag() {
            return this.languageFlag || this.getLanguageFlag();
        },
        userInfo: {
            get() {
                return JSON.parse(this.secureLocalStorage('user'));
            },
            set() { /* opsiyonel */ },
        },
        activeLanguage: {
            get() {
                return i18nService.getActiveLanguage();
            },
            set(value) {
                i18nService.setActiveLanguage(value);
            }
        },
        getLanguageFlag() {
            return this.onLanguageChanged();
        },
    },
    methods: {
        selectedLanguage(e) {
            const el = e.target.closest(".navi-link");
            const lang = el.getAttribute("data-lang");

            i18nService.setActiveLanguage(lang);
            const langObj = this.languages.find(val => val.lang === lang);

            localStorage.setItem("activeLanguage", lang);
            localStorage.setItem("languageFlag", langObj.flag);

            // Sayfayı reload et
            window.location.reload();
        },

        isActiveLanguage(current) {
            return this.activeLanguage === current;
        },
        onLanguageChanged() {
            const currentLang = localStorage.getItem("activeLanguage") || i18nService.getActiveLanguage();
            const langObj = this.languages.find(val => val.lang === currentLang);

            this.activeLanguage = currentLang;
            this.languageFlag = langObj ? langObj.flag : '';
        }
    },
    mounted() {
        const cachedLang = localStorage.getItem("activeLanguage");
        const cachedFlag = localStorage.getItem("languageFlag");

        if (cachedLang && cachedFlag) {
            this.activeLanguage = cachedLang;
            this.languageFlag = cachedFlag;
            i18nService.setActiveLanguage(cachedLang);
        } else {
            this.onLanguageChanged(); 
        }
    },


};
</script>
<style scoped>
@import '../../homepage-assets/css/bootstrap.min.css';
@import '../../homepage-assets/css/lineicons.css';
@import '../../homepage-assets/css/animate.css';
@import '../../homepage-assets/css/main.css';
@import '../../homepage-assets/css/custom.css';

.socials {
    list-style: none;
    padding: 0;
    display: flex;
    margin-top: 80px;
}

.socials li a {
    text-decoration: none;
    font-size: 32px;
    color: #000;
    transition: transform 0.3s, color 0.3s;
}

.socials li a:hover {
    transform: scale(1.2);
}

.socials li a:hover .uil-instagram {
    color: #E1306C;
}

.socials li a:hover .uil-linkedin {
    color: #0077B5;
}

.socials li a:hover .uil-whatsapp {
    color: #25D366;
}
</style>
